module.exports = __webpack_public_path__ + "static/media/external-link.0b37a079.svg";